import { useTranslation } from 'react-i18next';
import { Certification } from '../../../../../../types/psychometric';
import CertificationItem from './CertificationItem';

interface CertificationSectionProps {
  certifications: Certification[];
}

export function CertificationSection({
  certifications,
}: CertificationSectionProps) {
  const { t } = useTranslation();
  if (!certifications?.length) return null;

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">{t('profile.certifications')}</h2>
      <div className="space-y-8">
        {certifications.map((certification, index) => (
          <CertificationItem key={index} certification={certification} />
        ))}
      </div>
    </div>
  );
}
